import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const home = async () => axios.get(Routes.HOME);

export const useHome = () =>
  useQuery({
    queryKey: [Keys.HOME_QRY],
    queryFn: home,
    cacheTime: 0,
  });
